import { message } from 'components';
import { useDeleteContactNoteMutation } from 'services';
import { ContactDto, DeleteContactNoteDto } from 'types';
export function useDeleteContactNote(contactId: number) {
  const [onUpdate, { isLoading }] = useDeleteContactNoteMutation();
  const onDeleteContactHandle = (
    values: Omit<DeleteContactNoteDto, 'contactId'>,
    onChangeSuccess?: (value: ContactDto) => void
  ) => {
    onUpdate({
      contactId,
      ...values
    })
      .unwrap()
      .then((rs) => {
        message.systemSuccess(rs.message);
        onChangeSuccess?.(rs.data);
      });
  };

  return {
    onDeleteContactHandle,
    isLoading
  };
}
